import { z } from "zod";

export const THINKING_LEVELS = ["off", "minimal", "low", "medium", "high", "xhigh"] as const;

export const thinkingLevelSchema = z.enum(THINKING_LEVELS);

export const runtimeSelectionSchema = z.object({
	model: z.string().trim().min(1).optional(),
	thinkingLevel: thinkingLevelSchema.optional(),
});

// Whitelists are always present: a profile's policy is "these models/levels
// are allowed, this one is the default". The default must be a member.
export const runtimePolicySchema = z.object({
	defaultModel: z.string().trim().min(1),
	allowedModels: z.array(z.string().trim().min(1)).min(1),
	defaultThinkingLevel: thinkingLevelSchema,
	allowedThinkingLevels: z.array(thinkingLevelSchema).min(1),
});

export type ThinkingLevel = z.infer<typeof thinkingLevelSchema>;
export type RuntimeSelection = z.infer<typeof runtimeSelectionSchema>;
export type RuntimePolicy = z.infer<typeof runtimePolicySchema>;
